<template>
  <div class="proj-new-nav-step">
    <ul>
      <template v-for="(item, $index) in navArr">
        <li class="nav-step" :key="$index + '_1'" @click="onNavStepClick(item, $index)">
          <div class="nav-image">
            <img :src="calcStepImg(item, $index)">
          </div>
          <div class="nav-title" :class="{ 'active' : $index === currIndex }">{{item.title}}</div>
        </li>
        <li class="nav-step-line" :key="$index + '_2'" :style="{ display : $index+1 === navArr.length ? 'none' : '' }">
          <div class="nav-dashed-line"></div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    navArr: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currIndex: 0
    };
  },
  created() {
    // 计算高亮的导航图标
    this.navArr.forEach((item, idx) => {
      let currRoutePath = this.$route.path;
      if (currRoutePath.indexOf(item.routePath) !== -1) {
        this.currIndex = idx;
      }
    });
  },
  methods: {
    // 计算步骤条的图标
    calcStepImg(item, idx) {
      if (idx < this.currIndex) {
        return item.finishImgSrc;
      } else if (idx === this.currIndex) {
        return item.activeImgSrc;
      } else {
        return item.initImgSrc;
      }
    },
    // 导航图标点击跳转
    onNavStepClick(item, idx) {
      if (this.disabled) {
        return;
      }
      this.$emit('beforeRouteChange');
      this.$router.push({ path: item.routePath + this.navArr[idx].params });
    }
  }
};
</script>

<style lang="less">
.proj-new-nav-step {
  ul {
    margin-top: 0px;
    padding-left: 0px;
    height: 60px;
    display: flex;
    justify-content: center;
    li {
      height: 100%;
      list-style: none;

      &.nav-step {
        width: 55px;
        cursor: pointer;

        .nav-image {
          height: 40px;
          width: 100%;
          // display: table-cell;
          // text-align: center;
          // vertical-align: bottom;
          display: flex;
          justify-content: center;
          align-items: flex-end;
        }
        .nav-title {
          text-align: center;
          white-space: nowrap;
          padding-top: 3px;
          color: #828282;
          &.active {
            color: #fb5b3b;
          }
          &:before {
            content: '';
            margin-left: -100%;
          }
          &:after {
            content: '';
            margin-right: -100%;
          }
        }
      }

      &.nav-step-line {
        width: 45px;
        display: flex;
        align-items: center;
        .nav-dashed-line {
          // position: relative;
          // top: 50%;
          // transform: translateY(-50%);
          width: 100%;
          border-bottom: 1px dashed #cccccc;
        }
      }
    }
  }
}
</style>
